module.exports = __webpack_public_path__ + "img/pinterest.5dd72eb4.svg";